import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    background: "#f8f9fc",
    position: "relative",
    minHeight: "100vh",
    display: "flex",
    flexDirection: "column",
    minWidth: 1200,
    overflowX: "auto"
  },
  content: {
    paddingTop: theme.spacing(8),
    flex: 1,
  },
  footer: {
    // position: "absolute",
    textAlign: "right",
    // borderTop: '1px solid #ddd',
    paddingRight: theme.spacing(3),
    lineHeight: 4,
    fontSize: 12,
    color: "#999",
    width: "100%",
    bottom: 0,
  },
}));

export default useStyles;
